import { useState } from 'react';
import { useLocation } from 'wouter';
import { useAuth } from '../contexts/AuthContext';
import { Mail, Lock, User } from 'lucide-react';

export default function Login() {
  const [, setLocation] = useLocation();
  const { login, register } = useAuth();
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (isLogin) {
        await login(email, password);
      } else {
        await register(email, password, username);
      }
      setLocation('/');
    } catch (err: any) {
      setError(err.message || '操作失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen gradient-bg flex flex-col items-center justify-center p-6">
      {/* Logo */}
      <div className="mb-8 text-center">
        <div className="w-20 h-20 mx-auto mb-4 rounded-2xl bg-gradient-accent flex items-center justify-center shadow-glow">
          <BookOpen size={40} className="text-white" />
        </div>
        <h1 className="text-3xl font-bold text-gradient mb-2">欢迎回来</h1>
        <p className="text-text-secondary">通过导入书籍生成您的知识卡片</p>
      </div>

      {/* Form */}
      <div className="w-full max-w-md glass-strong rounded-2xl p-6">
        {/* Tab */}
        <div className="flex gap-2 mb-6 p-1 glass rounded-xl">
          <button
            onClick={() => setIsLogin(true)}
            className={`flex-1 py-2 rounded-lg font-medium transition-all ${
              isLogin
                ? 'bg-primary text-white shadow-glow'
                : 'text-text-secondary'
            }`}
          >
            登录
          </button>
          <button
            onClick={() => setIsLogin(false)}
            className={`flex-1 py-2 rounded-lg font-medium transition-all ${
              !isLogin
                ? 'bg-primary text-white shadow-glow'
                : 'text-text-secondary'
            }`}
          >
            注册
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {!isLogin && (
            <div className="relative">
              <User className="absolute left-4 top-1/2 -translate-y-1/2 text-text-secondary" size={20} />
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="用户名"
                className="w-full pl-12 pr-4 py-3 bg-bg-secondary rounded-xl text-text-primary placeholder-text-secondary focus:outline-none focus:ring-2 focus:ring-primary"
                required={!isLogin}
              />
            </div>
          )}

          <div className="relative">
            <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-text-secondary" size={20} />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="邮箱"
              className="w-full pl-12 pr-4 py-3 bg-bg-secondary rounded-xl text-text-primary placeholder-text-secondary focus:outline-none focus:ring-2 focus:ring-primary"
              required
            />
          </div>

          <div className="relative">
            <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-text-secondary" size={20} />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="密码"
              className="w-full pl-12 pr-4 py-3 bg-bg-secondary rounded-xl text-text-primary placeholder-text-secondary focus:outline-none focus:ring-2 focus:ring-primary"
              required
            />
          </div>

          {isLogin && (
            <div className="text-right">
              <button
                type="button"
                className="text-sm text-primary hover:underline"
              >
                忘记密码?
              </button>
            </div>
          )}

          {error && (
            <div className="p-3 bg-red-500/20 border border-red-500/50 rounded-xl text-red-300 text-sm">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-4 bg-gradient-accent rounded-xl text-white font-medium shadow-glow hover:scale-105 active:scale-95 transition-transform disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? '处理中...' : isLogin ? '登录' : '注册'}
          </button>
        </form>

        {isLogin && (
          <div className="mt-6">
            <div className="text-center text-text-secondary text-sm mb-4">其他登录方式</div>
            <div className="flex justify-center gap-4">
              <button className="w-12 h-12 glass rounded-xl flex items-center justify-center hover:bg-bg-secondary transition-colors">
                <Mail size={20} className="text-primary" />
              </button>
            </div>
          </div>
        )}

        <div className="mt-6 text-center text-xs text-text-secondary">
          继续即表示您同意我们的
          <button className="text-primary hover:underline ml-1">服务条款</button>
        </div>
      </div>
    </div>
  );
}

// Missing import
import { BookOpen } from 'lucide-react';

